import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import HistoryIcon from "@mui/icons-material/History";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import { Link } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import { config } from "../../config";
import "../../scss/main.scss";
import "./assets/layout.scss";
// Helper function to require icons dynamically
const getIcon = (project, iconName) => {
    try {
        return require(`../../assets/${project}Icons/${project}_${iconName}.svg`).default;
    }
    catch (e) {
        console.error(`Icon not found: ${project}_${iconName}.svg`);
        return "";
    }
};
// Pre-load all icons for each project
const getZippyyIcon = (iconName) => getIcon("zippyy", iconName);
const getBigshipIcon = (iconName) => getIcon("bigship", iconName);
const getShipnexaIcon = (iconName) => getIcon("shipnexa", iconName);
// Icon objects
const zippyyIcons = {
    Billing: getZippyyIcon("Billing"),
    bulkAction: getZippyyIcon("bulkAction"),
    rateCard: getZippyyIcon("rateCard"),
    configuration_icon: getZippyyIcon("configuration_icon"),
    ShipmentDispute: getZippyyIcon("ShipmentDispute"),
    AdminPanel: getZippyyIcon("AdminPanel"),
    integration: getZippyyIcon("integration"),
    vasControl: getZippyyIcon("vasControl"),
    Invoicing: getZippyyIcon("Invoicing"),
    FinalCharges: getZippyyIcon("FinalCharges"),
    weightDispute: getZippyyIcon("weightDispute"),
};
const bigshipIcons = {
    Billing: getBigshipIcon("Billing"),
    bulkAction: getBigshipIcon("bulkAction"),
    rateCard: getBigshipIcon("rateCard"),
    configuration_icon: getBigshipIcon("configuration_icon"),
    ShipmentDispute: getBigshipIcon("ShipmentDispute"),
    AdminPanel: getBigshipIcon("AdminPanel"),
    integration: getBigshipIcon("integration"),
    vasControl: getBigshipIcon("vasControl"),
    Invoicing: getBigshipIcon("Invoicing"),
    FinalCharges: getBigshipIcon("FinalCharges"),
    weightDispute: getBigshipIcon("weightDispute"),
};
const shipnexaIcons = {
    Billing: getShipnexaIcon("Billing"),
    bulkAction: getShipnexaIcon("bulkAction"),
    rateCard: getShipnexaIcon("rateCard"),
    configuration_icon: getShipnexaIcon("configuration_icon"),
    ShipmentDispute: getShipnexaIcon("ShipmentDispute"),
    AdminPanel: getShipnexaIcon("AdminPanel"),
    integration: getShipnexaIcon("integration"),
    vasControl: getShipnexaIcon("vasControl"),
    Invoicing: getShipnexaIcon("Invoicing"),
    FinalCharges: getShipnexaIcon("FinalCharges"),
    weightDispute: getShipnexaIcon("weightDispute"),
};
const ListItems = (props) => {
    const itemData = props.itemData;
    const [open, setOpen] = React.useState(false);
    // Get theme color from config
    const primaryColor = config.theme.primaryColor;
    // Get icon based on current project
    const getIconByProject = (iconName) => {
        const project = config.project;
        if (project === "zippyy") {
            return zippyyIcons[iconName];
        }
        else if (project === "bigship") {
            return bigshipIcons[iconName];
        }
        else if (project === "shipnexa") {
            return shipnexaIcons[iconName];
        }
        return zippyyIcons[iconName];
    };
    React.useEffect(() => {
        setOpen(itemData.subItems ? itemData.subItems.filter((x) => x.active).length > 0 : false);
    }, [itemData.subItems]);
    const handleClick = () => {
        setOpen(!open);
    };
    const renderIcon = (name, isActive = false) => {
        switch (name) {
            case "rateManagement":
                return (React.createElement("img", { style: { width: "16px", height: "16px" }, src: getIconByProject("Billing"), alt: "Rate Management" }));
            case "bulkaction":
                return React.createElement("img", { style: { width: "16px", height: "16px" }, src: getIconByProject("bulkAction"), alt: "Bulk Action" });
            case "ratecard":
                return React.createElement("img", { style: { width: "16px", height: "16px" }, src: getIconByProject("rateCard"), alt: "Rate Card" });
            case "notification":
                return (React.createElement("img", { style: { width: "16px", height: "16px" }, src: getIconByProject("configuration_icon"), alt: "Notification" }));
            case "misB2B":
                return (React.createElement("img", { style: { width: "16px", height: "16px" }, src: require("../../assets/order/MisB2B.svg").default, alt: "misB2B" }));
            case "shipmentDispute":
                return (React.createElement("img", { style: { width: "15px", height: "15px" }, src: getIconByProject("ShipmentDispute"), alt: "Shipment Dispute" }));
            case "AdminPanel":
                return React.createElement("img", { style: { width: "16px", height: "16px" }, src: getIconByProject("AdminPanel"), alt: "Admin Panel" });
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    const renderSubIcon = (iconName, isActive = false) => {
        if (iconName === "audit-logs") {
            return (React.createElement(HistoryIcon, { sx: { width: "18px", height: "18px", color: isActive ? primaryColor : "#666666" } }));
        }
        if (iconName === "finance") {
            return (React.createElement(AccountBalanceWalletIcon, { sx: { width: "18px", height: "18px", color: isActive ? primaryColor : "#666666" } }));
        }
        if (iconName === "remittance-approvals") {
            return (React.createElement(PendingActionsOutlinedIcon, { sx: { width: "18px", height: "18px", color: isActive ? primaryColor : "#666666" } }));
        }
        const iconMap = {
            "carrier-rate-controls": "integration",
            "default-carrier-config": "integration",
            "vas-controls": "vasControl",
            "rate-configuration": "configuration_icon",
            invoicing: "Invoicing",
            finalCharges: "FinalCharges",
            weightDispute: "weightDispute",
        };
        const mappedName = iconMap[iconName] || iconName;
        return (React.createElement("img", { style: {
                width: "18px",
                height: "18px",
            }, src: getIconByProject(mappedName), alt: iconName }));
    };
    return (React.createElement(List, { disablePadding: true },
        React.createElement(ListItem, { key: itemData.rootItem.name, disablePadding: true, sx: { display: "block" } },
            itemData.subItems && itemData.subItems.length ? (React.createElement(ListItemButton, { onClick: handleClick, selected: itemData.rootItem.active, className: itemData.rootItem.active ? "nv_active_border" : "", sx: {
                    borderLeft: itemData.rootItem.active ? `4px solid ${primaryColor} !important` : "none",
                } },
                React.createElement(ListItemIcon, { className: (itemData.rootItem.active ? "nv_active" : "nv_color") + " nv_margin_align_items" }, renderIcon(itemData.rootItem.icon, itemData.rootItem.active)),
                React.createElement(ListItemText, { primary: itemData.rootItem.name, className: (itemData.rootItem.active ? "nv_active" : "") + "nv_font_style nv_font_size_14", sx: {
                        color: itemData.rootItem.active ? primaryColor : "#000000",
                        opacity: props.isDrawerOpen ? 1 : 0,
                    } }),
                itemData.subItems && itemData.subItems.length && props.isDrawerOpen ? (open ? (React.createElement(ExpandLess, { sx: { color: open ? primaryColor : "#666666" } })) : (React.createElement(ExpandMore, { sx: { color: open ? primaryColor : "#666666" } }))) : null)) : (React.createElement(Link, { style: { textDecoration: "none" }, href: itemData.rootItem.path },
                React.createElement(ListItemButton, { onClick: () => props.setActive(itemData), selected: itemData.rootItem.active, className: itemData.rootItem.active ? "nv_active_border" : "", sx: {
                        borderLeft: itemData.rootItem.active ? `4px solid ${primaryColor} !important` : "none",
                    } },
                    React.createElement(ListItemIcon, { className: (itemData.rootItem.active ? "nv_active" : "nv_color") + " nv_margin_align_items" }, renderIcon(itemData.rootItem.icon, itemData.rootItem.active)),
                    React.createElement(ListItemText, { primary: itemData.rootItem.name, sx: {
                            color: itemData.rootItem.active ? primaryColor : "#000000",
                            opacity: props.isDrawerOpen ? 1 : 0,
                        }, className: (itemData.rootItem.active ? "nv_active" : "") + "nv_font_style nv_font_size_14" })))),
            itemData.subItems && itemData.subItems.length && props.isDrawerOpen && (React.createElement(Collapse, { in: open, timeout: "auto", unmountOnExit: true },
                React.createElement(List, { component: "div", disablePadding: true }, itemData.subItems.map((item, i) => {
                    return (React.createElement(Link, { key: i, style: { textDecoration: "none" }, href: item.path },
                        React.createElement(ListItemButton, { sx: {
                                pl: 4,
                                // Remove border for child items
                            }, onClick: () => props.setActive(itemData, item) },
                            React.createElement(ListItemIcon, { className: "nv_margin_align_child" }, renderSubIcon(item.icon, item.active)),
                            React.createElement(ListItemText, { primary: item.name, sx: {
                                    color: item.active ? primaryColor : "#000000",
                                }, className: item.active
                                    ? "nv_font_style nv_font_size_14 nv_active"
                                    : "nv_font_style nv_font_size_14 m_font_color_bk" }))));
                })))))));
};
export default ListItems;
